module.exports = __webpack_public_path__ + "files/6f03f372654d6cc21daa17d9ae4dbd01.png";